import { useDatabaseContent } from '@databases/database-state';
import { defaultStoreUtils } from '@databases/redux';
import { selectValueSingle } from '@databases/redux/cellSelections/actions';
import { useEffect } from 'react';

export interface PopoverSoftSelectionProps {
  entryId: string | undefined;
  fieldId: string;
  isRenderedInSidePanel: boolean | undefined;
  clearExistingSelection?: boolean;
}

export const usePopoverSoftSelection = ({
  entryId,
  fieldId,
  isRenderedInSidePanel,
  clearExistingSelection = false,
}: PopoverSoftSelectionProps) => {
  const dispatch = defaultStoreUtils.useDispatch();

  const { contentId } = useDatabaseContent();

  useEffect(() => {
    // No need to set softSelection if popover is rendered in side panel
    if (!isRenderedInSidePanel && entryId && contentId) {
      dispatch(
        selectValueSingle({
          contentId,
          entryId,
          fieldId,
          clearExistingSelection,
        })
      );
    }
  }, [
    dispatch,
    entryId,
    fieldId,
    clearExistingSelection,
    isRenderedInSidePanel,
    contentId,
  ]);
};
